export default __webpack_public_path__ + "static/media/belur.1d98a394.jpg";